import { ArrowRightIcon, ChangingIcon, useMobile } from "@cpj-ai/panel-npm-package";
import { Button, Card } from "@heroui/react";
import { OrgRegistrationStepEnum, useOrganizationProfileStore } from "@store/useOrganizationProfileStore";
import { ReactNode, useCallback } from "react";

interface VerificationLayoutProps {
  verifyType?: string;
  children: ReactNode;
  showTypeSection?: boolean;
}

const VerificationLayout = ({ verifyType, children, showTypeSection = true }: VerificationLayoutProps) => {
  const isMobile = useMobile();
  const { setOrgRegistrationStep } = useOrganizationProfileStore();

  const handleChangeMethod = useCallback(() => {
    setOrgRegistrationStep(OrgRegistrationStepEnum.selectVerificationMethod);
  }, [setOrgRegistrationStep]);

  const handleGoToProfile = useCallback(() => {
    setOrgRegistrationStep(OrgRegistrationStepEnum.orgInfoForm);
  }, [setOrgRegistrationStep]);

  const Container = isMobile ? "div" : Card;
  return (
    <>
      <div className="flex items-center gap-1 mb-5">
        <Button isIconOnly variant="light" className="pr-1 pb-2 min-w-0 w-fit h-fit" onPress={handleGoToProfile}>
          <ArrowRightIcon stroke="#000" className="rotate-180 w-8 h-8 " />
        </Button>
        <p className="text-lg font-semibold mt-1">Verify Organization account</p>
      </div>
      <Container className="md:py-8 px-4 md:px-6">
        {showTypeSection && verifyType && (
          <div className="flex items-center gap-4">
            <p className="text-zinc-500">Verify Type : </p>
            <p className="hidden md:block">{verifyType}</p>
            <Button
              onPress={handleChangeMethod}
              variant="bordered"
              color="warning"
              className="border-2 rounded-xl border-none md:border-2 w-fit px-0 md:px-4"
            >
              <ChangingIcon className="w-5 h-5 fill-yellow-500" />
              change
            </Button>
          </div>
        )}
        {children}
      </Container>
    </>
  );
};

export default VerificationLayout;
